export default __webpack_public_path__ + "static/media/docx.3e06eec3.svg";